import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';
import { ILoginOtpStep2Response } from '../../../entity/interface/iLoginEntities';

export interface ILoginOtpStep2UseCase {
    execute(language: string, username: string, agent: string, otp: string): Promise<ILoginOtpStep2Response>;
}

export class LoginOtpStep2UseCase implements ILoginOtpStep2UseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(language: string, username: string, agent: string, otp: string): Promise<ILoginOtpStep2Response> {
        return await this.userRepo.loginOtpStep2(language, username, agent, otp);
    }
}
